// Styles
import "./App.css";
// Third-Party =====> react-router-dom
import { Routes, Route } from "react-router-dom";
// Layout
import Layout from "./layout/Layout.js";
// Pages
import Home from "./pages/Home.js";
import About from "./pages/About.js";
import Careers from "./pages/Careers.js";
// import BusinessPartners from "./pages/BusinessPartners.js";
// import Success from "./Components/CareersComponents/Success";
import CardDetails from "./Components/CareersComponents/CardDetails";
// import JoinBusinessPartener from "./Components/JoinBusinessPartener";
// import PartnerSuccess from "./Components/PartnersComponents/PartnersSuccess";

function App() {
   return (
      <div className="App">
         <Routes>
            <Route element={<Layout />}>
               <Route index element={<Home />} />
               <Route path="career">
                  <Route index element={<Careers />} />
                  <Route path=":careerIDinfo" element={<CardDetails />} />
               </Route>
               <Route path="about" element={<About />} />
               {/* <Route path="partners">
                  <Route index element={<BusinessPartners />} />
                  <Route
                     path="join_business_partner"
                     element={<JoinBusinessPartener />}
                  />
               </Route> */}
            </Route>
            {/* <Route path="/success" element={<Success />} />
            <Route
               path="/partners/join_business_partner/success"
               element={<PartnerSuccess />}
            /> */}
         </Routes>
      </div>
   );
}

export default App;
